module.exports = __webpack_public_path__ + "res/33-img_game_score.421be54130326a088053382ad287e4a9.png";